import { useOnClickOutside } from 'hooks/useOnClickOutside'
import { ReactElement, useRef, useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather'
import { useTheme } from 'styled-components/macro'

import { DropDown, DropDownItem, DropDownListWrap, DropDownValue, DropDownWrap } from './styles'

interface IProps {
  value: string
  items?: string[]
  className?: string
  onChange: (value: any) => void
}

export default function ChartDropDown({ value, items = [], onChange, className }: IProps): ReactElement {
  const theme = useTheme()
  const [isOpened, setIsOpened] = useState(false)
  const node = useRef<HTMLDivElement>()

  useOnClickOutside(node, () => {
    if (isOpened) setIsOpened(false)
  })

  const chevronProps = {
    height: 20,
    width: 20,
    color: theme.textSecondary,
  }

  return (
    <DropDownWrap ref={node as any} className={className}>
      <DropDown>
        <DropDownValue
          onClick={() => {
            setIsOpened(!isOpened)
          }}
        >
          <span>{value}</span>
          {isOpened ? <ChevronUp {...chevronProps} /> : <ChevronDown {...chevronProps} />}
        </DropDownValue>
        {isOpened && (
          <DropDownListWrap>
            {items.map((v, index) => (
              <DropDownItem
                key={index}
                onClick={() => {
                  onChange(v)
                }}
                active={v === value}
              >
                {v}
              </DropDownItem>
            ))}
          </DropDownListWrap>
        )}
      </DropDown>
    </DropDownWrap>
  )
}
